import React from "react";

const EligibilityFailed = ({
  isEligibilityFailedOpen,
  closeEligibilityFailed,
  loanProductName,
  reasons,
  handleTryAnotherProduct,
  handleCloseEligibilityFailed,
}) => {
  if (!isEligibilityFailedOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-10 ">
      <div className="bg-white shadow-lg w-[670px] rounded-sm p-8 flex flex-col items-center text-center relative">
        {" "}
        <button
          onClick={closeEligibilityFailed}
          className="absolute top-4 right-4 text-gray-700 hover:text-gray-900 text-xl font-bold leading-none"
        >
          &times;
        </button>
        <div>
          <img src="/failed.png" alt="Ineligible" className="w-12 h-12" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          Member Ineligible
        </h2>
        <p className="text-gray-600 text-sm mb-4 leading-relaxed">
          This member does not meet all the requirements and is not eligible to
          apply for a{" "}
          <span className="font-semibold">
            {loanProductName || "[loan_productname]"}
          </span>
        </p>
        <div className="bg-red-50 border border-red-200 p-3 rounded-md max-h-40 overflow-y-auto">
          <p className="font-semibold text-red-600 mb-2">Reasons:</p>

          <ul className="list-disc pl-5 space-y-1 text-gray-700 text-sm">
            {reasons?.map((reason, index) => (
              <li key={index}>{reason}</li>
            ))}
          </ul>
        </div>
        <div className="flex justify-center items-center space-x-4 mt-6">
          <button
            onClick={handleCloseEligibilityFailed}
            className="border border-[#074073] text-[14px] text-[#074073] w-[211px] h-[49px] rounded-md font-medium whitespace-nowrap transition-colors duration-200"
          >
            Close
          </button>
      
        </div>
      </div>
    </div>
  );
};

export default EligibilityFailed;